export default __webpack_public_path__ + "static/media/ver-mas.925e4415.svg";